import Encounter from "@/encounter/model/Encounter.ts";
import type Combatant from "@/encounter/model/Combatant.ts";
import {http} from "@/api/HttpClient.ts";

export type TurnState = {
    round: number;
    activeCombatantId?: string;
    revision: number;
    turnOrder: string[];
    combatId?: string;
    phase: "IDLE" | "PREPARING" | "INITIATIVE" | "ACTIVE";
    participants: CombatParticipant[];
};

export type CombatParticipant = {
    participationId: string;
    combatantId: string;
    nameAtJoin: string;
    surprised: boolean;
    joinedRound: number;
    firstEligibleRound: number;
    initiative?: number | null;
};

/** Display projection only; initiative is persisted exclusively in CombatParticipant. */
export type CombatTurnToken = Combatant & {initiative?: number};

export type CombatCommand = {
    action: "BEGIN_PREPARATION" | "SET_PARTICIPANTS" | "REQUEST_INITIATIVE" | "CANCEL_PREPARATION" | "SET_INITIATIVES" | "START_COMBAT" | "ADD_PARTICIPANTS" | "RESET_COMBAT";
    expectedRevision: number;
    participants?: {combatantId: string; surprised: boolean}[];
    initiatives?: {combatantId: string; initiative: number | null}[];
};

export type CombatCommandResult = {
    state: TurnState;
    transition: {
        action: CombatCommand["action"];
        actionId: string;
        occurredAt: string;
        performedBy: string;
        before: TurnState;
        after: TurnState;
    };
};

export type TurnStateUpdate = Pick<TurnState, "round" | "activeCombatantId" | "turnOrder"> & {expectedRevision: number};

export async function applyCombatCommand(encounter: Encounter, command: CombatCommand): Promise<CombatCommandResult> {
    const response = await http.post<CombatCommandResult>(`/encounters/${encounter.id}/combat/commands`, command);
    return response.data;
}

export async function getTurnState(encounter: Encounter): Promise<TurnState> {
    const response = await http.get<TurnState>(`/encounters/${encounter.id}/turn`);
    return response.data;
}

export async function saveTurnState(encounter: Encounter, update: TurnStateUpdate): Promise<TurnState> {
    const response = await http.put<TurnState>(`/encounters/${encounter.id}/turn`, update);
    return response.data;
}
